var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallZenith(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_7235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76868 12.542L4.83994 12.257L4.91119 11.9007L8.04623 0.643066L41.3917 0.714317L4.55493 30.711L21.3702 10.4045H8.75874L8.04623 10.4757C6.54996 10.547 5.19619 11.4732 4.76868 12.542Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6102 21.2345C39.6102 21.092 38.5415 27.5758 36.7602 34.2734L1.91846 34.4872L39.539 4.06299L22.6525 24.512H35.3352L36.0477 24.4408C37.544 24.3695 39.1115 22.3032 39.6102 21.2345Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55006 43.8209H0.63623L4.69754 38.2633H1.99L2.20375 36.6958H7.83258L3.77127 42.2534H6.76382L6.55006 43.8209ZM7.69008 43.8209L8.61634 36.6958H12.6776L12.4639 38.2633H10.1839L10.0414 39.4746H12.1789L12.0364 41.0421H9.82761L9.68511 42.2534H11.9651L11.7514 43.8209H7.69008ZM12.9627 43.8209L13.8889 36.6958H15.6702L17.7365 40.4009L17.879 40.8284L18.164 41.6121C18.1682 41.16 18.192 40.7084 18.2352 40.2584L18.6627 36.6958H20.444L19.5177 43.8209H17.8077L15.7414 40.1871L15.5277 39.6883L15.2427 38.9046C15.239 39.3804 15.2152 39.8558 15.1714 40.3296L14.7439 43.8209H12.9627ZM21.014 43.8209L21.9403 36.6958H23.7928L22.8665 43.8209H21.014ZM25.2891 43.8209L26.0016 38.4058H24.5053L24.7191 36.6958H29.5641L29.3504 38.4058H27.8541L27.1416 43.8209H25.2891ZM29.4929 43.8209L30.4191 36.6958H32.2717L31.9154 39.4746H34.3379L34.6942 36.6958H36.5467L35.6205 43.8209H33.7679L34.1242 40.8996H31.7017L31.3454 43.8209H29.4929Z",
    fill: "#808285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_7235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.7556,
    height: 43.1781,
    fill: "white",
    transform: "translate(0.63623 0.643066)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallZenith);
export default __webpack_public_path__ + "static/media/smallZenith.0bf6d262d4f8ac264416018f6c3edcb2.svg";
export { ForwardRef as ReactComponent };